var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 214,
    viewBox: "0 0 285 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8054 184.151H73.647V210.913H49.5581V184.151H0V162.791L46.0179 87.3066H73.6444V165.023H87.8027V184.151H87.8054ZM49.5581 165.02V111.449L18.3101 165.02H49.5581Z",
    fill: "#00A7AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.913 102.401C182.332 113.552 185.541 129.395 185.541 149.923C185.541 170.454 182.332 186.267 175.913 197.359C169.494 208.454 158.314 214 142.371 214C126.425 214 115.246 208.454 108.829 197.359C102.41 186.267 99.2031 170.454 99.2031 149.923C99.2031 129.395 102.41 113.552 108.832 102.401C115.248 91.2487 126.428 85.6741 142.374 85.6741C158.314 85.6741 169.494 91.2513 175.913 102.401ZM127.866 182.734C130.226 190.311 135.06 194.1 142.371 194.1C149.68 194.1 154.472 190.314 156.745 182.734C159.02 175.157 160.156 164.222 160.156 149.923C160.156 134.941 159.02 123.846 156.745 116.639C154.469 109.435 149.68 105.832 142.371 105.832C135.06 105.832 130.226 109.435 127.866 116.639C125.504 123.846 124.326 134.941 124.326 149.923C124.329 164.222 125.507 175.157 127.866 182.734Z",
    fill: "#00A7AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.481 184.151H270.323V210.913H246.234V184.151H196.676V162.791L242.694 87.3066H270.32V165.023H284.481V184.151ZM246.234 165.02V111.449L214.986 165.02H246.234Z",
    fill: "#00A7AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M116.319 18.8978C118.26 12.3174 114.464 5.4198 107.841 3.4915C101.218 1.5632 94.2753 5.33444 92.3345 11.9148C90.3937 18.4952 94.1894 25.3928 100.813 27.3211C107.436 29.2494 114.378 25.4781 116.319 18.8978Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M112.19 11.5988C111.739 11.5988 111.321 11.3093 111.18 10.8609C110.736 9.44765 109.765 8.29257 108.445 7.60683C107.128 6.92108 105.616 6.7855 104.196 7.22615C103.637 7.39824 103.044 7.09056 102.868 6.53519C102.695 5.97981 103.005 5.39054 103.564 5.21585C105.524 4.60832 107.608 4.79345 109.429 5.74254C111.251 6.68903 112.589 8.28475 113.203 10.2351C113.376 10.7905 113.067 11.3797 112.508 11.5544C112.403 11.5831 112.295 11.5988 112.19 11.5988Z",
    fill: "#00A7AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8711 1.21606C91.985 3.6644 87.5892 12.0002 90.0508 19.8355C92.5151 27.6707 100.905 32.0381 108.791 29.5923C116.677 27.144 121.073 18.8082 118.612 10.9729C116.15 3.1351 107.757 -1.23229 99.8711 1.21606ZM108.059 27.2561C101.472 29.3003 94.4623 25.6526 92.4049 19.1054C90.3474 12.5608 94.0188 5.59648 100.609 3.55228C107.196 1.50808 114.205 5.15583 116.263 11.703C118.32 18.2476 114.646 25.2093 108.059 27.2561Z",
    fill: "#D0DAED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.891 28.7372L107.406 29.5085L110.942 40.7528L113.427 39.9815L109.891 28.7372Z",
    fill: "#D0DAED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.529 60.5629C116.941 61.0557 115.254 60.1771 114.758 58.5996L109.323 41.3099C109.06 40.473 109.53 39.5838 110.37 39.3231L113.068 38.4861C113.91 38.2254 114.805 38.6921 115.067 39.5265L120.502 56.8135C121.001 58.3936 120.117 60.0701 118.529 60.5629Z",
    fill: "#00A7AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.58 52.9675C119.58 52.9675 113.98 49.5361 112.293 47.7631C110.602 45.9875 109.889 45.1818 110.324 44.8063C110.76 44.4308 115.486 46.4985 115.943 46.1491C116.4 45.7997 116.001 44.9341 116.515 44.543C117.029 44.1519 120.079 47.2755 120.803 47.0382C121.522 46.801 120.423 52.4147 119.58 52.9675Z",
    fill: "#FFAA9D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2483 116.859L93.1412 120.807L82.7383 111.24L86.1604 105.707L97.2483 116.859Z",
    fill: "#FFAA9D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7422 120.225C93.7422 120.225 90.8791 123.789 90.3385 123.797C89.8005 123.802 77.7888 110.893 77.8676 110.476C77.9463 110.061 83.1897 110.507 83.1897 110.507L93.7422 120.225Z",
    fill: "url(#paint0_linear_2048_326)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5195 105.131C85.5195 105.131 97.5469 117.623 98.0088 117.623C98.4733 117.623 155.868 73.8425 155.868 73.8425L131.537 63.1209C131.54 63.1182 100.646 71.5558 85.5195 105.131Z",
    fill: "#061421"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.005 108.875L142.041 114.179L129.093 119.915L125.324 114.609L140.005 108.875Z",
    fill: "#FFAA9D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.648 63.1179C129.648 63.1179 109.335 67.3289 107.574 74.1628C105.816 80.9968 107.414 88.4644 113.012 97.2044C118.61 105.944 124.304 115.451 125.477 115.761C125.477 115.761 140.518 109.775 140.859 109.029C141.2 108.283 132.435 87.7109 132.435 87.7109C132.435 87.7109 150.291 86.5297 154.458 76.0715L129.648 63.1179Z",
    fill: "#061421"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.232 63.0554C128.048 64.2444 150.234 78.0532 154.163 77.3857C158.089 76.7182 163.17 60.6123 161.765 48.587C160.361 36.5617 149.52 27.5401 144.576 27.9625C139.632 28.3823 136.986 32.9869 136.312 40.3111C135.325 51.0536 128.439 61.7283 128.232 63.0554Z",
    fill: "url(#paint1_linear_2048_326)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.787 29.811C149.403 29.5841 158.402 34.8276 160.507 50.2973C162.611 65.7669 154.014 67.0654 146.787 66.0642C139.562 65.063 121.38 56.2004 118.717 53.035C118.717 53.035 118.142 48.0523 120.076 46.2871C120.076 46.2871 137.614 48.0601 142.168 49.4186C146.721 50.7744 136.869 30.6688 146.787 29.811Z",
    fill: "url(#paint2_linear_2048_326)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.743 113.402C141.743 113.402 143.914 117.422 143.706 117.915C143.499 118.41 126.826 124.295 126.472 124.061C126.118 123.826 128.595 119.211 128.595 119.211L141.743 113.402Z",
    fill: "url(#paint3_linear_2048_326)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.092 19.762L132.008 25.2923L132.84 25.2662C132.84 25.2662 133.506 29.8422 136.758 29.1199C137.692 28.9113 138.884 28.1265 139.227 28.283C139.634 28.4681 139.81 29.7222 139.904 30.0847C140.259 31.4692 145.137 30.069 144.347 28.6506C143.597 27.3026 142.476 25.4618 142.715 24.9507C143.542 23.1699 143.778 18.7425 139.293 17.2641C135.716 16.0856 132.131 17.8716 132.092 19.762Z",
    fill: "#FFAA9D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.348 28.6481C143.597 27.3001 142.477 25.4593 142.715 24.9482C142.715 24.9482 140.831 27.8268 139.094 28.2622C139.091 28.2622 139.089 28.2648 139.086 28.2648C139.141 28.2622 139.194 28.2622 139.23 28.2805C139.637 28.4656 139.813 29.7198 139.907 30.0822C140.259 31.4693 145.138 30.0692 144.348 28.6481Z",
    fill: "#FF9F91"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.619 22.4739C141.713 22.1193 140.414 26.7578 142.721 26.604C145.03 26.4502 146.639 21.4335 144.943 17.5668C143.248 13.7 140.025 13.9138 136.955 14.4431C133.884 14.9698 130.118 16.3517 130.121 18.6593C130.126 24.213 136.742 19.5536 137.178 21.2223C137.517 22.513 138.036 26.2494 136.687 26.3354C135.338 26.4215 133.968 25.3185 132.903 25.6001C132.289 25.7644 130.604 33.0469 135.01 33.2893C139.372 33.5292 140.474 29.7068 139.556 26.5831C138.684 23.6107 138.595 22.6486 139.619 22.4739Z",
    fill: "#061421"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2048_326",
    x1: 86.9463,
    y1: 113.931,
    x2: 84.387,
    y2: 117.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14336D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9662,
    stopColor: "#0E2253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2048_326",
    x1: 135.012,
    y1: 35.4906,
    x2: 150.76,
    y2: 65.1745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3162DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    stopColor: "#173DB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2048_326",
    x1: 139.724,
    y1: 49.8044,
    x2: 157.616,
    y2: 87.7697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3162DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    stopColor: "#173DB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2048_326",
    x1: 133.245,
    y1: 117.131,
    x2: 135.168,
    y2: 120.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14336D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9662,
    stopColor: "#0E2253"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.6be8fee91fd894a9fcaaf603b0a0eb22.svg";
export { ForwardRef as ReactComponent };